/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/variables.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/
import lpApp from '../lp_app';
import ConditionsEvo from '../../logic/condition_evo';

class LpVariablesIndex {
  constructor() {
    this.variables = {};
  }

  updateVariable(var_, i = 0) {
    if (var_) {
      let changeStatus = false;
      if (this.variables[var_.id] && this.variables[var_.id].value !== var_.value) {
        changeStatus = true;
      } else if (!this.variables[var_.id]) changeStatus = true;

      this.variables[var_.id] = { value: var_.value, index: i };


      if (changeStatus === true) ConditionsEvo.execVariableHook(var_.id);
    }
  }

  loadFromO() {
    const os = lpApp.getState().loadedOvc.vF;
    if (os && Object.keys(os).length > 0)
      Object.keys(os).map(idx => this.updateVariable({ id: idx, value: os[idx] }), this);
  }

  delVariable(id) {
    if (Object.prototype.hasOwnProperty.call(this.variables, id)) delete this.variables[id];
  }

  getVariable(id) {
    if (this.variables[id]) return this.variables[id];
    // let loaded_variable = getVariablePass(id)
    // if(loaded_variable)
    //     return {value: loaded_variable};
    return { value: '' };
  }
}


export default LpVariablesIndex;



// WEBPACK FOOTER //
// ./src/app/indexes/variables.js